import axios from "axios";
import store from "@/store";
import baseUrlFactory from "./common.js";

const publicClient = axios.create({
  baseURL: baseUrlFactory(),
  withCredentials: true
});

/*
 * Add a response interceptor
 */
publicClient.interceptors.response.use(
  response => {
    return response;
  },
  function(error) {
    if (
      error.response &&
      [401, 419].includes(error.response.status) &&
      store.getters.isProfileLoaded &&
      store.getters.isAuthenticated
    ) {
      store.dispatch("logout");
    }
    return Promise.reject(error);
  }
);

export default publicClient;
